// extracted by mini-css-extract-plugin
export default {"heading":"PersonalInfoFields_heading__UPX83","wrap":"PersonalInfoFields_wrap__PqYEX"};